// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/database.js';

import { paths } from '../generated/database';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('database', Original, paths);
